/**
 * Smart backend URL resolver.
 *
 * - In preview (app hosted on emergentagent.com), `REACT_APP_BACKEND_URL`
 *   points to the preview backend → use it.
 * - In production (app hosted on custom domain selfieboothevent.fr),
 *   the `REACT_APP_BACKEND_URL` baked at build-time may still point to
 *   the preview domain. Since backend and frontend share the same origin
 *   via the Emergent ingress (`/api/*` is routed to the backend),
 *   `window.location.origin` is the safest same-origin base URL.
 *
 * Rule:
 *   - If the window origin matches REACT_APP_BACKEND_URL → use it as-is.
 *   - If the window origin is an Emergent preview → use REACT_APP_BACKEND_URL.
 *   - Otherwise (custom domain in prod) → use window.location.origin.
 */
const ENV_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

export const getBackendUrl = () => {
  if (typeof window === "undefined") return ENV_URL;
  const origin = window.location.origin.replace(/\/$/, "");
  if (!ENV_URL) return origin;
  if (origin === ENV_URL) return origin;
  // Preserve preview preview URL when hosted on emergent agent
  if (/(^|\.)emergentagent\.com$|(^|\.)emergent\.host$/i.test(window.location.hostname)) {
    return ENV_URL;
  }
  // Custom production domain → same-origin wins
  return origin;
};

export default getBackendUrl;
